import { Type } from "@sinclair/typebox";
const text = Type.String({ maxLength: 4000 });
export const InspectionSaveSchema = Type.Object(
  {
    operationId: Type.String({ format: "uuid" }),
    id: Type.String({ format: "uuid" }),
    revision: Type.Integer({ minimum: 0 }),
    status: Type.Union([Type.Literal("draft"), Type.Literal("completed")]),
    form: Type.Object(
      {
        signature: Type.Optional(
          Type.Array(
            Type.Array(
              Type.Object(
                {
                  x: Type.Number({ minimum: 0, maximum: 1 }),
                  y: Type.Number({ minimum: 0, maximum: 1 }),
                },
                { additionalProperties: false },
              ),
              { maxItems: 1000 },
            ),
            { maxItems: 100 },
          ),
        ),
        templateVersion: Type.Literal("cem-lv-2026-09-v1"),
        date: Type.String({ format: "date" }),
        technician: Type.String({ maxLength: 240 }),
        answers: Type.Record(
          Type.String({ pattern: "^s[1-7]-[1-7]$" }),
          Type.Union(["yes", "no", "na", "nv"].map((v) => Type.Literal(v))),
          { maxProperties: 35 },
        ),
        temperature: Type.Union([
          Type.Number({ minimum: -80, maximum: 80 }),
          Type.Null(),
        ]),
        methods: Type.Array(Type.String({ maxLength: 100 }), {
          maxItems: 4,
          uniqueItems: true,
        }),
        otherMethod: text,
        outcome: Type.Union([
          Type.Null(),
          ...["usable", "restricted", "specialist", "out-of-service"].map((v) =>
            Type.Literal(v),
          ),
        ]),
        notes: text,
        technicianConfirmed: Type.Boolean(),
      },
      { additionalProperties: false },
    ),
  },
  { additionalProperties: false },
);
